{
    "status": {
        "connecting": "Conectando",
        "open": "Abierta",
        "closed": "Cerrada"
    }
}
